import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=45d56766&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"
import style0 from "./HamburgerMenu.vue?vue&type=style&index=0&id=45d56766&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d56766",
  null
  
)

export default component.exports